import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';

import Button from 'layout/atoms/Button/Button';

function PageControls({ currentPage, pages, t, onPreviousClick, onNextClick }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
      <Button leftIcon="<" shape="squared" onClick={onPreviousClick} />
      {currentPage && pages && (
        <Button>
          {t('page')} {currentPage}/{pages}
        </Button>
      )}
      <Button leftIcon=">" shape="squared" onClick={onNextClick} />
    </div>
  );
}

export default withTranslation()(memo(PageControls));
